module.exports = __webpack_public_path__ + "img/img-26.591658d4.png";